import type { Stone } from '../domain/types';

/** MVP第一弾の5種。
 *  低ティア3 + 中ティア1 + レア1。
 *  後に拡張予定(20種以上)。 */
export const stones: Stone[] = [
  {
    id: 'rose-quartz',
    name: 'ローズクォーツ',
    rarity: 'low',
    lore: '愛と癒しの石。柔らかな光が、持ち主の心を温めてくれる。持つ人の優しさを引き出し、傷ついた心をそっと包む。',
    geometryParams: {
      type: 'sphere',
      baseColor: '#f4a8c1',
      glowColor: '#ffd6e7',
    },
    energyCost: 5,
  },
  {
    id: 'amethyst',
    name: 'アメジスト',
    rarity: 'low',
    lore: '知恵と平静の石。紫の光が、思考をクリアに保ち、迷いを取り除く。深夜の瞑想に寄り添う。',
    geometryParams: {
      type: 'octahedron',
      baseColor: '#9966cc',
      glowColor: '#d9b3ff',
    },
    modelUrl: '/models/diamond.glb',
    modelScale: 0.9,
    modelAutoBrighten: true,
    energyCost: 5,
  },
  {
    id: 'citrine',
    name: 'シトリン',
    rarity: 'low',
    lore: '太陽と繁栄の石。黄金の光が、前向きな気力と豊かさを呼び込む。困難に立ち向かう勇気を授ける。',
    geometryParams: {
      type: 'dodecahedron',
      baseColor: '#e6b800',
      glowColor: '#ffe680',
    },
    energyCost: 5,
  },
  {
    id: 'lapis-lazuli',
    name: 'ラピスラズリ',
    rarity: 'mid',
    lore: '真理と王の石。星を散りばめたような紺碧の光が、持つ人の判断力を研ぎ澄ます。古来、王と賢者の石。',
    geometryParams: {
      type: 'octahedron',
      baseColor: '#1e3a8a',
      glowColor: '#7dd3fc',
    },
  },
  {
    id: 'rainbow-fluorite',
    name: 'レインボーフローライト',
    rarity: 'high',
    lore: '集中と精神統一の最高峰。虹色の光が、持つ人の意識を高次の波動へと導く。最も稀有な覚醒の石。',
    geometryParams: {
      type: 'dodecahedron',
      baseColor: '#7c3aed',
      glowColor: '#fde68a',
    },
  },
];

export function getStoneById(id: string): Stone | undefined {
  return stones.find((s) => s.id === id);
}
